module.exports = __webpack_public_path__ + "static/media/malousci.324f3ca8.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/devdata/resources/sponsors/malousci.png
// module id = 494
// module chunks = 0